export const ACTION = 'UPDATE_DICTIONARY';

export default payload => ({ type: ACTION, payload });



// WEBPACK FOOTER //
// ./src/apps/lexikon/data/redux/actions/updateDictionary.js